import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles'
import { connect } from 'react-redux'
import { IconButton, Snackbar, Menu, MenuItem, Grid, Typography, Table, TableHead, TableBody, TableRow, TableCell } from '@material-ui/core'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import MoreVertIcon from '@material-ui/icons/MoreVert'
import { SwxTheme } from 'swx-atomic-component-lib'

import _ from 'lodash'

import { loadEnterpriseUsers, updateEnterpriseUser } from '../../actions/enterprises'
import { hideNotification } from '../../actions/notifications'
import i18n from '../../i18n'

const styles = theme => ({
  table: {
    backgroundColor: SwxTheme.palette.white,
    marginTop: 16
  },
  tableCell: {
    paddingLeft: 8,
    paddingRight: 16,
    '&:last-of-type': {
      paddingRight: 8,
      textAlign: 'center'
    }
  }
})

class EnterpriseManagerUsers extends Component {
  state = {
    anchorElement: null,
    enterprise: {
      users: []
    }
  }

  constructor (props) {
    super(props)
    this.classes = props.classes
  }

  componentDidMount = () => {
    const { loggedInUser } = this.props
    if (loggedInUser.Enterprise) {
      this.props.loadEnterpriseUsers(loggedInUser.Enterprise.id)
    }
  }

  openCloseMenu (e, toEditUser = null) {
    this.setState({ anchorElement: e ? e.currentTarget : null, toEditUser })
  }

  handleOnClickDisable = () => {
    const { toEditUser } = this.state
    const { loggedInUser } = this.props
    const data = {
      disableUser: true
    }
    this.props.updateEnterpriseUser(loggedInUser.Enterprise.id, toEditUser.id, data)
  }

  handleOnClickEnabled = () => {
    const { toEditUser } = this.state
    const { loggedInUser } = this.props
    const data = {
      disableUser: false
    }
    this.props.updateEnterpriseUser(loggedInUser.Enterprise.id, toEditUser.id, data)
  }

  handleOnClickSetPassword = () => {
    const { toEditUser } = this.state
    const { loggedInUser } = this.props
    const data = {
      setTemporaryPassword: true
    }
    this.props.updateEnterpriseUser(loggedInUser.Enterprise.id, toEditUser.id, data)
  }

  handleOnClickForceLogout = () => {
    const { toEditUser } = this.state
    const { loggedInUser } = this.props
    const data = {
      forceLogout: true
    }
    this.props.updateEnterpriseUser(loggedInUser.Enterprise.id, toEditUser.id, data)
  }

  handleOnSnackbarClose = (e) => {
    this.props.hideNotification()
  }

  render () {
    const { classes, updated, notification, loggedInUser } = this.props
    const { toEditUser } = this.state
    return (
      <Grid container direction='column'>
        <Grid item>
          <>
            <Typography variant='subtitle1' color='primary'>{i18n.enterprise.users.tab}</Typography>
            <Typography variant='body2'>{i18n.enterprise.users.desc}</Typography>
            <Table className={classes.table}>
              <TableHead>
                <TableRow>
                  <TableCell className={classes.tableCell}>{i18n.enterprise.users.table.column.firstName}</TableCell>
                  <TableCell className={classes.tableCell}>{i18n.enterprise.users.table.column.lastName}</TableCell>
                  <TableCell className={classes.tableCell}>{i18n.enterprise.users.table.column.email}</TableCell>
                  <TableCell className={classes.tableCell}>{i18n.enterprise.users.table.column.status.label}</TableCell>
                  <TableCell width={20} className={classes.tableCell} />
                </TableRow>
              </TableHead>
              {this.props.users &&
                <TableBody>
                  {this.props.users.map((user, index) => {
                    return (
                      <TableRow key={index}>
                        <TableCell className={classes.tableCell}>{user.first_name}</TableCell>
                        <TableCell className={classes.tableCell}>{user.last_name}</TableCell>
                        <TableCell className={classes.tableCell}>{user.email}</TableCell>
                        <TableCell className={classes.tableCell}>{user.is_verified ? i18n.enterprise.users.table.column.status.verified : i18n.enterprise.users.table.column.status.pending}</TableCell>
                        <TableCell className={classes.tableCell}>
                          {
                            (user.id !== loggedInUser.id) &&
                              <IconButton
                                aria-owns={this.state.anchorElement ? 'user-menu' : null}
                                aria-haspopup='true'
                                aria-label='Options'
                                onClick={e => this.openCloseMenu(e, user)}
                              >
                                <MoreVertIcon />
                              </IconButton>
                          }
                        </TableCell>
                      </TableRow>
                    )
                  })}
                </TableBody>}
            </Table>
            <Menu
              id='user-menu'
              anchorEl={this.state.anchorElement}
              open={!_.isEmpty(this.state.anchorElement)}
              onClose={() => this.openCloseMenu(null)}
            >
              {
                (toEditUser && toEditUser.is_disabled) ? <MenuItem onClick={this.handleOnClickEnabled}>{i18n.enterprise.users.menu.enable}</MenuItem> : <MenuItem onClick={this.handleOnClickDisable}>{i18n.enterprise.users.menu.disable}</MenuItem>
              }
              <MenuItem onClick={this.handleOnClickSetPassword}>{i18n.enterprise.users.menu.setPassword}</MenuItem>
              <MenuItem onClick={this.handleOnClickForceLogout}>{i18n.enterprise.users.menu.forceLogout}</MenuItem>
            </Menu>
            <Snackbar
              anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
              open={notification && notification.showNotification}
              autoHideDuration={10000}
              onClose={this.handleOnSnackbarClose}
              ContentProps={{
                'aria-describedby': 'message-id'
              }}
              message={
                <CopyToClipboard text={`${updated ? updated.tempPassword : ''}`}>
                  <span id='message-id'>{notification && notification.text}</span>
                </CopyToClipboard>
              }
            />
          </>
        </Grid>
      </Grid>
    )
  }
}

EnterpriseManagerUsers.propTypes = {
}

function mapStateToProps (state) {
  return {
    users: state.enterprise.users,
    updated: state.enterprise.updated,
    openModal: state.enterprise.openModal,
    loggedInUser: state.self.user,
    notification: state.notification
  }
}

const EnterpriseManagerUsersComponent = withStyles(styles)(EnterpriseManagerUsers)

export default connect(mapStateToProps, { loadEnterpriseUsers, updateEnterpriseUser, hideNotification })(EnterpriseManagerUsersComponent)
